module.exports = __webpack_public_path__ + "static/media/mergedUnit-gray.4a039bf3.svg";